import { LandPlot } from 'lucide-react';

interface Props {
  /** hectares de imóveis próprios */
  propria: number;
  /** hectares de áreas arrendadas */
  arrendada: number;
}

const fmt = (n: number) => n.toLocaleString('pt-BR', { maximumFractionDigits: 2 });

// Card de destaque da ficha 360° (design ARA): soma total de hectares do
// produtor, com quebra próprios × arrendados. Coral só no chip do ícone.
export function AreaTotalCard({ propria, arrendada }: Props) {
  const total = propria + arrendada;
  if (total <= 0) return null;

  return (
    <div className="flex w-full items-center gap-5 self-stretch rounded-[14px] border border-border bg-surface px-6 py-4 font-ui">
      <span className="grid size-12 shrink-0 place-items-center rounded-xl bg-accent">
        <LandPlot strokeWidth={2} className="size-6 text-[var(--on-solid)]" />
      </span>

      <div className="flex flex-col gap-0.5">
        <span className="text-[11px] font-medium uppercase tracking-wide text-text-muted">
          Área total
        </span>
        <span className="text-[26px] font-bold leading-tight text-text">{fmt(total)} ha</span>
      </div>

      <div className="ml-auto flex items-center gap-5">
        <div className="flex flex-col gap-0.5">
          <span className="text-[11px] font-medium uppercase tracking-wide text-text-muted">
            Próprios
          </span>
          <span className="text-[15px] font-medium text-text">{fmt(propria)} ha</span>
        </div>
        <span className="h-9 w-px bg-border" />
        <div className="flex flex-col gap-0.5">
          <span className="text-[11px] font-medium uppercase tracking-wide text-text-muted">
            Arrendados
          </span>
          <span className="text-[15px] font-medium text-text">{fmt(arrendada)} ha</span>
        </div>
      </div>
    </div>
  );
}
